import { SxProps } from '@mui/material';

export const OutfitStagesModalSx: SxProps = {
	padding: 0,
	display: 'flex',
};

export const OutfitStagesModalRootSx: SxProps = {
	zIndex: { xs: 9999, md: undefined },
};

export const OutfitStagesModalInnerSx: SxProps = {
	width: '100vw',
	height: '100dvh',
	display: 'flex',
	alignItems: { xs: 'auto', md: 'center' },
	justifyContent: { xs: 'auto', md: 'center' },
};

export const OutfitStagesModalContentSx: SxProps = {
	width: { xs: '100%', md: '886px' },
	height: { xs: '100%', md: 'auto' },
	minHeight: { md: '575px' },
	maxWidth: { md: 'calc(100vw - 40px)' },
	maxHeight: { md: 'calc(100dvh - 40px)' },
	background: 'white',
	outline: 'none',
	borderRadius: { xs: 0, md: '4px' },
	boxShadow: { md: '0 24px 64px rgba(0, 0, 0, 0.18)' },
	overflow: 'hidden',
	display: 'flex',
	flexDirection: 'column',
	position: 'relative',
};

export const OutfitStagesHeaderSx: SxProps = {
	flexShrink: 0,
	padding: { xs: '20px 20px 0px 20px', md: '15px 30px' },
	borderBottom: { md: '1px solid #EEEEEE' },
};

export const OutfitStagesBodySx: SxProps = {
	flex: '1 1 auto',
	minHeight: 0,
	display: { xs: 'flex', md: 'grid' },
	flexDirection: 'column',
	gridTemplateColumns: { md: 'auto 1fr' },
	gridTemplateRows: { md: 'minmax(0, 1fr)' },
	gap: { xs: '5px', md: '30px' },
	padding: { xs: '12px 20px 20px 20px', md: '24px 40px' },
	overflowY: { xs: 'auto', md: 'hidden' },
};

export const OutfitStagesImageZoneSx: SxProps = {
	flexShrink: 0,
	minHeight: 0,
	alignSelf: { md: 'start' },
};

export const OutfitStagesListZoneSx: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	minHeight: { xs: '250px', md: 0 },
	overflowY: { md: 'auto' },
};

export const OutfitStagesListSkeletonSx: SxProps = {
	flex: 1,
	width: '100%',
	height: '100%',
	borderRadius: '4px',
};

export const OutfitStagesFooterSx: SxProps = {
	flexShrink: 0,
	backgroundColor: '#F6F4F9',
	borderTop: '1px solid #ECE8F1',
	padding: {
		xs: '16px 20px calc(16px + env(safe-area-inset-bottom))',
		md: '16px 40px',
	},
};
